import classnames from "classnames/bind";
import styles from './TopMenu.module.scss';
import {
    BellOutlined,
    GoldOutlined, LoginOutlined,
    MoonOutlined, SecurityScanOutlined,
    SunOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Avatar, Badge, Dropdown} from "antd";
import {useContext, useEffect, useState} from "react";
import ItemDropDown from "./ItemDropDown/ItemDropDown";
import {Link, useActionData, useNavigate} from "react-router-dom";
import {redirectAuth} from "../../routes/web";
import {numberFormat} from "../../helpers/helpers";
import logout from "../../api/auth/logout";
import LoadingContext from "../../contexts/LoadingContext";
import useAuth from "../../hooks/useAuth";

const cx = classnames.bind(styles);

function TopMenu({balance}) {
    const { signOut } = useAuth();
    const navigate  = useNavigate();
    const {setLoading} = useContext(LoadingContext);

    const handleSignOut = async () => {
        setLoading(true);
        try {
            // Gọi API logout trước
            const response = await logout();
            if (response.success) {
                signOut();
                navigate(redirectAuth);
            }
        } catch (error) {
            console.error('Logout error:', error);
            // Vẫn đăng xuất local nếu API thất bại
            signOut();
            navigate(redirectAuth);
        }
        setLoading(false);
    }

    const items = [
        {
            key: 'profile',
            label: (
                <ItemDropDown icon={<UserOutlined/>} to={'/user/profile'}>Trang cá nhân</ItemDropDown>
            ),
        },
        {
            key: 'security',
            label: (
                <ItemDropDown icon={<SecurityScanOutlined/>} to={'/user/security'}>Bảo mật</ItemDropDown>
            ),
        },
        {
            key: 'logout',
            label: (
                <ItemDropDown onClick={handleSignOut} icon={<LoginOutlined/>}>Đăng xuất</ItemDropDown>
            )
        }
    ];
    return (
        <div
            className={cx('wrapper')}
        >
            <div
                className={cx('icon')}
            >
                <Dropdown
                    placement={'bottomRight'}
                    arrow={{
                        pointAtCenter: true,
                    }}
                    menu={{
                        items
                    }}
                >
                    <Avatar size={'default'} icon={<UserOutlined />} />
                </Dropdown>
            </div>
        </div>
    )
}

export default TopMenu;
